import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationsFacade } from "src/app/facades/notifications.facade";

@Component({
  selector: 'fspro-navbar-rh',
  templateUrl: './navbar-rh.component.html',
  styleUrls: ['./navbar-rh.component.scss'],
  standalone: false
})
export class NavbarRhComponent {
  public displayInviteTooltip: boolean = false;
  public isToggleToolbar: boolean;

  constructor(
    private readonly router: Router,
    public notificationsFacade: NotificationsFacade,
  ) {}

  public isActive(route: string): boolean {
    return this.router.isActive(route, {
      paths: 'exact',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  public displayInviteTooltipToggle(): void {
    this.displayInviteTooltip = true;
  }

  public displayInviteTooltipClose(): void {
    this.displayInviteTooltip = false;
  }
}
